/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskOverrideHistoryRecord } from './InternalApiFinalRiskOverrideHistoryRecord';
import {
    InternalApiFinalRiskOverrideHistoryRecordFromJSON,
    InternalApiFinalRiskOverrideHistoryRecordFromJSONTyped,
    InternalApiFinalRiskOverrideHistoryRecordToJSON,
    InternalApiFinalRiskOverrideHistoryRecordToJSONTyped,
} from './InternalApiFinalRiskOverrideHistoryRecord';

/**
 * 
 * @export
 * @interface InternalApiFinalRiskOverrideHistoryPage
 */
export interface InternalApiFinalRiskOverrideHistoryPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideHistoryPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideHistoryPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideHistoryPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiFinalRiskOverrideHistoryRecord>}
     * @memberof InternalApiFinalRiskOverrideHistoryPage
     */
    content: Array<InternalApiFinalRiskOverrideHistoryRecord>;
}

/**
 * Check if a given object implements the InternalApiFinalRiskOverrideHistoryPage interface.
 */
export function instanceOfInternalApiFinalRiskOverrideHistoryPage(value: object): value is InternalApiFinalRiskOverrideHistoryPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskOverrideHistoryPageFromJSON(json: any): InternalApiFinalRiskOverrideHistoryPage {
    return InternalApiFinalRiskOverrideHistoryPageFromJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideHistoryPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskOverrideHistoryPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiFinalRiskOverrideHistoryRecordFromJSON)),
    };
}

export function InternalApiFinalRiskOverrideHistoryPageToJSON(json: any): InternalApiFinalRiskOverrideHistoryPage {
    return InternalApiFinalRiskOverrideHistoryPageToJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideHistoryPageToJSONTyped(value?: InternalApiFinalRiskOverrideHistoryPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiFinalRiskOverrideHistoryRecordToJSON)),
    };
}

